// Main texts aggregation file with language support
import { getCurrentLanguage } from './language';

// French imports
import { COMMON_TEXTS as COMMON_TEXTS_FR } from './fr/common';
import { AUTH_TEXTS as AUTH_TEXTS_FR } from './fr/auth';
import { USERS_TEXTS as USERS_TEXTS_FR } from './fr/users';
import { ORGANIZATIONS_TEXTS as ORGANIZATIONS_TEXTS_FR } from './fr/organizations';
import { LOCATIONS_TEXTS as LOCATIONS_TEXTS_FR } from './fr/locations';
import { SENSORS_TEXTS as SENSORS_TEXTS_FR } from './fr/sensors';
import { ALERTS_TEXTS as ALERTS_TEXTS_FR } from './fr/alerts';
import { EVENTS_TEXTS as EVENTS_TEXTS_FR } from './fr/events';
import { ACCOUNT_TEXTS as ACCOUNT_TEXTS_FR } from './fr/account';
import { DATA_TEXTS as DATA_TEXTS_FR } from './fr/data';
import { NAVIGATION_TEXTS as NAVIGATION_TEXTS_FR } from './fr/navigation';
import { ROLES_TEXTS as ROLES_TEXTS_FR } from './fr/roles';
import { PAGINATION_TEXTS as PAGINATION_TEXTS_FR } from './fr/pagination';
import { ERROR_TEXTS as ERROR_TEXTS_FR } from './fr/errors';
import { LAYOUT_TEXTS as LAYOUT_TEXTS_FR } from './fr/layout';
import { DASHBOARD_TEXTS as DASHBOARD_TEXTS_FR } from './fr/dashboard';
import { NOTIFICATION_TEXTS as NOTIFICATION_TEXTS_FR } from './fr/notifications';
import { DATE_TIME_TEXTS as DATE_TIME_TEXTS_FR } from './fr/dateTime';
import { LEGAL_TEXTS as LEGAL_TEXTS_FR } from './fr/legal';
import { DOCUMENT_SEARCH_TEXTS as DOCUMENT_SEARCH_TEXTS_FR } from './fr/documentSearch';
import { ADDRESS_BOOK_TEXTS as ADDRESS_BOOK_TEXTS_FR } from './fr/addressBook';

// English imports
import { COMMON_TEXTS as COMMON_TEXTS_EN } from './en/common';
import { AUTH_TEXTS as AUTH_TEXTS_EN } from './en/auth';
import { USERS_TEXTS as USERS_TEXTS_EN } from './en/users';
import { ORGANIZATIONS_TEXTS as ORGANIZATIONS_TEXTS_EN } from './en/organizations';
import { LOCATIONS_TEXTS as LOCATIONS_TEXTS_EN } from './en/locations';
import { SENSORS_TEXTS as SENSORS_TEXTS_EN } from './en/sensors';
import { ALERTS_TEXTS as ALERTS_TEXTS_EN } from './en/alerts';
import { EVENTS_TEXTS as EVENTS_TEXTS_EN } from './en/events';
import { ACCOUNT_TEXTS as ACCOUNT_TEXTS_EN } from './en/account';
import { DATA_TEXTS as DATA_TEXTS_EN } from './en/data';
import { NAVIGATION_TEXTS as NAVIGATION_TEXTS_EN } from './en/navigation';
import { ROLES_TEXTS as ROLES_TEXTS_EN } from './en/roles';
import { PAGINATION_TEXTS as PAGINATION_TEXTS_EN } from './en/pagination';
import { ERROR_TEXTS as ERROR_TEXTS_EN } from './en/errors';
import { LAYOUT_TEXTS as LAYOUT_TEXTS_EN } from './en/layout';
import { DASHBOARD_TEXTS as DASHBOARD_TEXTS_EN } from './en/dashboard';
import { NOTIFICATION_TEXTS as NOTIFICATION_TEXTS_EN } from './en/notifications';
import { DATE_TIME_TEXTS as DATE_TIME_TEXTS_EN } from './en/dateTime';
import { LEGAL_TEXTS as LEGAL_TEXTS_EN } from './en/legal';
import { DOCUMENT_SEARCH_TEXTS as DOCUMENT_SEARCH_TEXTS_EN } from './en/documentSearch';
import { ADDRESS_BOOK_TEXTS as ADDRESS_BOOK_TEXTS_EN } from './en/addressBook';

// Language-specific text collections
const TEXTS_FR = {
  common: COMMON_TEXTS_FR,
  auth: AUTH_TEXTS_FR,
  users: USERS_TEXTS_FR,
  organizations: ORGANIZATIONS_TEXTS_FR,
  locations: LOCATIONS_TEXTS_FR,
  sensors: SENSORS_TEXTS_FR,
  alerts: ALERTS_TEXTS_FR,
  events: EVENTS_TEXTS_FR,
  account: ACCOUNT_TEXTS_FR,
  data: DATA_TEXTS_FR,
  nav: NAVIGATION_TEXTS_FR,
  roles: ROLES_TEXTS_FR,
  pagination: PAGINATION_TEXTS_FR,
  errors: ERROR_TEXTS_FR,
  layout: LAYOUT_TEXTS_FR,
  dashboard: DASHBOARD_TEXTS_FR,
  notifications: NOTIFICATION_TEXTS_FR,
  dateTime: DATE_TIME_TEXTS_FR,
  legal: LEGAL_TEXTS_FR,
  documentSearch: DOCUMENT_SEARCH_TEXTS_FR,
  addressBook: ADDRESS_BOOK_TEXTS_FR
} as const;

const TEXTS_EN = {
  common: COMMON_TEXTS_EN,
  auth: AUTH_TEXTS_EN,
  users: USERS_TEXTS_EN,
  organizations: ORGANIZATIONS_TEXTS_EN,
  locations: LOCATIONS_TEXTS_EN,
  sensors: SENSORS_TEXTS_EN,
  alerts: ALERTS_TEXTS_EN,
  events: EVENTS_TEXTS_EN,
  account: ACCOUNT_TEXTS_EN,
  data: DATA_TEXTS_EN,
  nav: NAVIGATION_TEXTS_EN,
  roles: ROLES_TEXTS_EN,
  pagination: PAGINATION_TEXTS_EN,
  errors: ERROR_TEXTS_EN,
  layout: LAYOUT_TEXTS_EN,
  dashboard: DASHBOARD_TEXTS_EN,
  notifications: NOTIFICATION_TEXTS_EN,
  dateTime: DATE_TIME_TEXTS_EN,
  legal: LEGAL_TEXTS_EN,
  documentSearch: DOCUMENT_SEARCH_TEXTS_EN,
  addressBook: ADDRESS_BOOK_TEXTS_EN
} as const;

// Get texts based on current language
const getTexts = () => {
  const currentLanguage = getCurrentLanguage();
  return currentLanguage === 'en' ? TEXTS_EN : TEXTS_FR;
};

// Export the dynamic text object
export const TEXTS = getTexts();

// Export individual text modules for backward compatibility
export const COMMON_TEXTS = getTexts().common;
export const AUTH_TEXTS = getTexts().auth;
export const USERS_TEXTS = getTexts().users;
export const LOCATIONS_TEXTS = getTexts().locations;
export const SENSORS_TEXTS = getTexts().sensors;
export const ALERTS_TEXTS = getTexts().alerts;
export const EVENTS_TEXTS = getTexts().events;
export const ACCOUNT_TEXTS = getTexts().account;
export const DATA_TEXTS = getTexts().data;
export const NAVIGATION_TEXTS = getTexts().nav;
export const ROLES_TEXTS = getTexts().roles;
export const PAGINATION_TEXTS = getTexts().pagination;
export const ERROR_TEXTS = getTexts().errors;
export const LAYOUT_TEXTS = getTexts().layout;
export const DASHBOARD_TEXTS = getTexts().dashboard;
export const NOTIFICATION_TEXTS = getTexts().notifications;
export const DATE_TIME_TEXTS = getTexts().dateTime;
export const LEGAL_TEXTS = getTexts().legal;